import { Component, effect } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular/standalone';
import { AccountService } from './account.service';
import { AuthService } from '@services/auth.service';
import { RegistrationService } from '@services/registration.service';

@Component({
  selector: 'app-account-base',
  template: '<ion-router-outlet></ion-router-outlet>',
  imports: [IonRouterOutlet],
  providers: [RegistrationService],
})
export class AccountBaseComponent {
  account?: any;
  isLoaded: boolean = false;

  constructor(
    private readonly accountService: AccountService,
    private readonly authService: AuthService,
  ) {
    effect(() => {
      const selectedAccount = this.authService.patientData;
      this.accountService.updateAccount(selectedAccount);
    });
  }
}
